function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 5.07a7.06 7.06 0 00-2 0V1.046a11.14 11.14 0 012 0V5.07zM7 12a5 5 0 1010 0 5 5 0 00-10 0zm8 0a3 3 0 11-6 0 3 3 0 016 0zm-2 10.955V18.93a7.062 7.062 0 01-2 0v4.026a11.17 11.17 0 002 0zM18.93 11h4.025a11.17 11.17 0 010 2H18.93a7.062 7.062 0 000-2zM5 12c0-.34.024-.673.07-1H1.046a11.14 11.14 0 000 2H5.07A7.06 7.06 0 015 12zm11.192-5.606l2.847-2.847c.513.427.987.9 1.414 1.414l-2.847 2.847a7.04 7.04 0 00-1.414-1.414zM3.547 4.96l2.847 2.847a7.04 7.04 0 011.414-1.414L4.96 3.547c-.513.427-.987.9-1.414 1.414zm14.06 11.231l2.846 2.847c-.427.513-.9.987-1.414 1.414l-2.847-2.847a7.04 7.04 0 001.414-1.414zM4.96 20.453l2.847-2.847a7.04 7.04 0 01-1.414-1.414L3.547 19.04c.427.513.9.987 1.414 1.414z",
  fill: "#000"
});

function SvgBrightnessHigh(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgBrightnessHigh;